'use client'

import { create } from 'zustand'

// Temporary toast notification (in-memory only)
export interface ToastNotification {
  id: string
  type: 'info' | 'warning' | 'error' | 'success'
  title: string
  message: string
  urgent?: boolean
  timestamp: string
}

interface ToastNotificationState {
  toasts: ToastNotification[]
  addToast: (toast: Omit<ToastNotification, 'id' | 'timestamp'>) => void
  dismissToast: (id: string) => void
  clearAllToasts: () => void
}

export const useToastNotificationStore = create<ToastNotificationState>()(
  (set, get) => ({
    toasts: [],

    addToast: toast => {
      const newToast: ToastNotification = {
        ...toast,
        id: Math.random().toString(36).slice(2, 11),
        timestamp: new Date().toISOString(),
      }

      set(state => ({
        toasts: [newToast, ...state.toasts],
      }))
    },

    dismissToast: id => {
      set(state => ({
        toasts: state.toasts.filter(t => t.id !== id),
      }))
    },

    clearAllToasts: () => {
      set({ toasts: [] })
    },
  })
)
